import { Checkbox } from "@/components/ui/checkbox";

interface HideRetiredFilterProps {
  /** Unique per page — the label's `htmlFor` target. */
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  /**
   * How many rows the filter is currently hiding. Reported beside the checkbox
   * so a shorter-than-expected list explains itself rather than looking like
   * missing data.
   */
  hiddenCount: number;
}

/**
 * The "Hide retired" toggle every Settings → Config list carries, ticked by
 * default so the live list is what you land on.
 *
 * Hiding is display-only: retired rows stay in the API response (labels and
 * change history depend on them) and every one of these lists sorts its
 * retired rows to the bottom, so what's hidden is always a suffix — never a
 * gap between two visible rows, which is what would break the reorder arrows.
 */
export function HideRetiredFilter({
  id,
  checked,
  onCheckedChange,
  hiddenCount,
}: HideRetiredFilterProps) {
  return (
    <div className="flex items-center gap-2 text-sm">
      <Checkbox id={id} checked={checked} onCheckedChange={(c) => onCheckedChange(c === true)} />
      <label htmlFor={id} className="cursor-pointer select-none">
        Hide retired
      </label>
      {checked && hiddenCount > 0 && (
        <span className="text-muted-foreground">({hiddenCount} hidden)</span>
      )}
    </div>
  );
}
